export const VAT_KIND_WITH_VAT = "with_vat";
export const VAT_KIND_ZERO = "zero";
export const VAT_KIND_NO_VAT = "no_vat";
export const DEFAULT_VAT_RATE = "22";

/**
 * Возвращает следующее значение ставки при смене типа НДС в форме.
 * null означает, что текущую ручную ставку нужно оставить без изменений.
 * @param {string|null} vatKind - Тип НДС
 * @param {string|number|null} currentVatRate - Текущая ставка НДС
 * @param {Object} [options]
 * @param {boolean} [options.useDefaultVatRate=true] - Подставлять дефолт для "С НДС"
 * @returns {string|null}
 */
export const nextVatRateForKind = (
  vatKind,
  currentVatRate = "",
  { useDefaultVatRate = true } = {}
) => {
  if (vatKind === VAT_KIND_ZERO) return "0";
  if (vatKind !== VAT_KIND_WITH_VAT) return "";
  if (!useDefaultVatRate) return null;
  if (
    currentVatRate === "" ||
    currentVatRate === null ||
    currentVatRate === undefined ||
    Number(currentVatRate) === 0
  ) {
    return DEFAULT_VAT_RATE;
  }

  return null;
};

/**
 * Возвращает тип НДС после ручного ввода ставки.
 * Если пользователь вручную вводит ставку, синхронизирует тип НДС:
 * пустое значение переключает на "Без НДС", 0 переключает на "НДС 0%",
 * положительная ставка переключает на "С НДС".
 * @param {string|null} vatKind - Текущий тип НДС
 * @param {string|number|null} vatRate - Введенная ставка НДС
 * @returns {string|null}
 */
export const nextVatKindForRateInput = (vatKind, vatRate) => {
  if (vatRate === "" || vatRate === null || vatRate === undefined) {
    return VAT_KIND_NO_VAT;
  }

  const rate = parseFloat(vatRate);
  if (Number.isNaN(rate) || rate < 0) return vatKind;
  if (rate === 0) return VAT_KIND_ZERO;

  return VAT_KIND_WITH_VAT;
};

/**
 * Проверяет, что ставка НДС заполнена корректно для типа "С НДС".
 * Для остальных типов ставка не обязательна.
 * @param {string|null} vatKind - Тип НДС
 * @param {string|number|null} vatRate - Ставка НДС
 * @param {Object} [options]
 * @param {boolean} [options.allowZeroWithVat=false] - Разрешить 0 для "С НДС"
 * @returns {boolean}
 */
export const vatRateIsInvalid = (
  vatKind,
  vatRate,
  { allowZeroWithVat = false } = {}
) => {
  if (vatKind !== VAT_KIND_WITH_VAT) return false;

  const rate = parseFloat(vatRate);
  if (vatRate === "" || Number.isNaN(rate)) return true;
  if (rate < 0) return true;

  return allowZeroWithVat ? false : rate <= 0;
};

/**
 * Нормализует ставку НДС для отправки в API.
 * @param {string|null} vatKind - Тип НДС
 * @param {string|number|null} vatRate - Ставка НДС из формы
 * @param {Object} [options]
 * @param {boolean} [options.zeroKindAsZero=true] - Отправлять zero как 0 вместо null
 * @returns {number|null}
 */
export const payloadVatRate = (
  vatKind,
  vatRate,
  { zeroKindAsZero = true } = {}
) => {
  if (vatKind === VAT_KIND_ZERO) return zeroKindAsZero ? 0 : null;
  if (vatKind !== VAT_KIND_WITH_VAT) return null;
  if (vatRate === "" || vatRate === null || vatRate === undefined) {
    return null;
  }

  return parseFloat(vatRate);
};
